export default "__VITE_ASSET__CFMtozN9__"